<div class="row mt-3 mb-3">
  <div class="col-3">
    <button (click)="adicionarIndicador()" #btnAdicionarIndicador class="btn btn-sm btn-outline-success">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar indicador
    </button>
  </div>
</div>
<table class="table table-eddy table-bordered" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Código</th>
      <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Indicador</th>
      <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Und.Medida</th>
      <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Recente</th>
      <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Futuro</th>
      <th scope="col" colspan="4" class="text-center">Metas</th>
      <th scope="col" rowspan="2"></th>
    </tr>
    <tr>
      <th scope="col" class="text-right">{{ano1}}</th>
      <th scope="col" class="text-right">{{ano2}}</th>
      <th scope="col" class="text-right">{{ano3}}</th>
      <th scope="col" class="text-right">{{ano4}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <th *ngIf="!item.editavel" scope="row" class="text-center">{{item.codigo}}</th>
      <td *ngIf="!item.editavel">{{item.nome}}</td>
      <td *ngIf="!item.editavel" class="text-center">{{item.unidade_medida}}</td>
      <td *ngIf="!item.editavel" class="text-center">{{item.recente | number:'1.2-2'}}</td>
      <td *ngIf="!item.editavel" class="text-center">{{item.futuro | number:'1.2-2'}}</td>
      <td *ngIf="!item.editavel" class="text-right">{{item.meta1 | number:'1.2-2'}}</td>
      <td *ngIf="!item.editavel" class="text-right">{{item.meta2 | number:'1.2-2'}}</td>
      <td *ngIf="!item.editavel" class="text-right">{{item.meta3 | number:'1.2-2'}}</td>
      <td *ngIf="!item.editavel" class="text-right">{{item.meta4 | number:'1.2-2'}}</td>

      <td *ngIf="item.editavel">
        <input [(ngModel)]="entity.codigo" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="codigo">
      </td>
      <td *ngIf="item.editavel">
        <input [(ngModel)]="entity.nome" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="nome">
      </td>
      <td *ngIf="item.editavel">
        <input [(ngModel)]="entity.unidade_medida" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="unidademed">
      </td>
      <td *ngIf="item.editavel">
        <input [(ngModel)]="entity.recente" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="recente" unmask="true" [imask]="imaskConfig">
      </td>
      <td *ngIf="item.editavel">
        <input [(ngModel)]="entity.futuro" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="futuro" unmask="true" [imask]="imaskConfig">
      </td>
      <td *ngIf="item.editavel">
        <input [(ngModel)]="entity.meta1" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="meta1" unmask="true" [imask]="imaskConfig">
      </td>
      <td *ngIf="item.editavel">
        <input [(ngModel)]="entity.meta2" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="meta2" unmask="true" [imask]="imaskConfig">
      </td>
      <td *ngIf="item.editavel">
        <input [(ngModel)]="entity.meta3" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="meta3" unmask="true" [imask]="imaskConfig">
      </td>
      <td *ngIf="item.editavel">
        <input [(ngModel)]="entity.meta4" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="meta4" unmask="true" [imask]="imaskConfig">
      </td>
      <td class="text-right" style="min-width: 100px;">
        <button *ngIf="item.editavel" (click)="salvarIndicador(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelarIndicador(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" #btnsEditar (click)="editarIndicador(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="removerIndicador(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>
